import React from 'react';
import { Radio, Check, GroupLabel } from '../../FormControls';
import Field from '../../Field';
import { familyPortalOpen, familyPortalWord } from '../../../domain/familyPortal';
import s from './eventDrawer.module.css';

// Visibility and the two booking options. First in the form because it is
// MMS's order, and because it decides who can even see the event.
//
// The Family Portal's half of this section follows its launch switch (#769,
// core/src/family_portal.rs). `visibility` and `allowOnlineBooking` are
// recorded whether or not the portal is open (#317) — the fold carries them to
// every occurrence, and the portal reads them — but while it is closed nothing
// a family could see is promised here:
//
// * the visibility radios carry no help line, because MMS's names a portal
//   calendar;
// * Maximum Students (#766), MMS's box under Allow online booking, is not
//   drawn. What it holds and what is written is `MAX_STUDENTS` in
//   core/src/events.rs: an event with booking on writes MMS's 1 when the box
//   has not been touched.
//
// Once it is open, the help lines are MMS's with our name (the core's
// `WORDING`), and the box shows while Allow online booking is ticked.
//
// `requiresMakeupCredit` (#362, #363): a flagged event books each attendee's
// credit forward (`bookable` in src/data/useMakeup.jsx), leaves an unmarked
// lesson unbilled, and offers the Use Make-Up Credit statuses in place of
// Present (`useAttendanceForm`). MMS has no help line on this box.

export default function GeneralSection({ form, set, shape, maxStudentsError = null }) {
  const open = familyPortalOpen();
  return (
    <>
      <h3 className={s.firstTitle}>General</h3>

      <GroupLabel>Visibility</GroupLabel>
      <Radio
        name="vis" label="Public"
        help={open ? familyPortalWord('visibilityPublicHelp') : undefined}
        checked={form.visibility === 'public'}
        onChange={() => set('visibility', 'public')}
      />
      <Radio
        name="vis" label="Private"
        help={open ? familyPortalWord('visibilityPrivateHelp') : undefined}
        checked={form.visibility === 'private'}
        onChange={() => set('visibility', 'private')}
      />
      {shape.makeupCredit || shape.onlineBooking ? (
        <div className={s.spaced}>
          <GroupLabel>Options</GroupLabel>
          {shape.makeupCredit ? (
            <Check
              label="This event requires a make-up credit"
              checked={form.requiresMakeupCredit}
              onChange={(e) => set('requiresMakeupCredit', e.target.checked)}
            />
          ) : null}
          {shape.onlineBooking ? (
            <Check
              label="Allow online booking"
              checked={form.allowOnlineBooking}
              onChange={(e) => set('allowOnlineBooking', e.target.checked)}
            />
          ) : null}
          {open && shape.onlineBooking && form.allowOnlineBooking ? (
            <Field label="Maximum Students" htmlFor="event-max-students" error={maxStudentsError}>
              <input
                id="event-max-students"
                className={s.input}
                type="number"
                inputMode="numeric"
                min="1"
                max="30"
                step="1"
                value={form.maxStudents ?? ''}
                onChange={(e) => set('maxStudents', e.target.value)}
              />
            </Field>
          ) : null}
        </div>
      ) : null}
    </>
  );
}
